<template>
  <ClientOnly>
    <ul class="dropdown-menu text-uppercase" v-for="menu in menuArray" :key="'menu' + menuArray.indexOf(menu)"
      :class="{ 'show': visible }" @mouseenter="onSubmenuMouseEnter" @mouseleave="onSubmenuMouseLeave">
      <li v-for="menuItem in menu" :key="menuItem.id">
        <b-link :to="menuItem.linkTo" style="text-decoration: none !important" @click="closeMainMenu" class="p-0">
          <h6 class="dropdown-header">{{ menuItem.name }}</h6>
        </b-link>
        <div class="p-2 pt-0 " v-if="!menuItem.dropMenu || menuItem.dropMenu.length === 0">
          <span class="d-block border-bottom border-dark border-2 dropdown-menu-border"></span>
        </div>
        <ul class="list-unstyled submenu-list">
          <li v-for="subItem in menuItem.dropMenu" :key="subItem.id">
            <b-link :to="`/${subItem.url_path}`" class="dropdown-item text-capitalize pt-0 pb-0" @click="closeMainMenu">
              {{ subItem.name }}
            </b-link>
            <div class="p-2 pt-0 ">
              <span class="d-block"></span>
            </div>
          </li>
        </ul>
      </li>
    </ul>
  </ClientOnly>
</template>

<script>
//import { Logger } from "@storefront/core/lib/logger";
import ClientOnly from "vue-client-only";
export default {
  name: "HeaderSubmenu",
  props: ["menuArray", "collapseId", "modelValue", "id", "isHam"],
  components: {
    ClientOnly,
  },
  data: () => ({
    //visible: false,
    me: this,
    readMore: {},
    hoverTimeout: null

  }),
  computed: {
    visible: {
      get() {
        return this.$store.getters["menu/getMenuItemState"](this.id).state;
      },
      set(val) {
        this.$store.commit("menu/updateMenuState", { id: this.id, state: val });
      },
    },
  },

  methods: {
    onSubmenuMouseEnter() {
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = null;
      }

      this.$store.commit("menu/updateMenuState", { id: this.id, state: true });

      this.$emit('submenu-enter', this.id);
    },

    onSubmenuMouseLeave() {

      this.$emit('submenu-leave', this.id);
    },

    showMore(id) {
      this.$set(this.readMore, id, true);
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    },
    close(e) {
      if (!this.$el.contains(e.target) && window.innerWidth > 991) {
        this.hoverTimeout = setTimeout(() => {
          this.visible = false;
        }, 100);
      }
    },
    closeInternal() {
      this.visible = false;
      this.$store.commit("menu/setNavBar", false);
    },
    sortMenu() {
      this.menuArray.forEach((menu, index) => {
        this.menuArray[index] = menu.sort((a, b) => b.position - a.position);
        this.menuArray[index].forEach((menuItem) => {
          if (menuItem.dropMenu && Array.isArray(menuItem.dropMenu)) {
            menuItem.dropMenu.sort((a, b) => b.position - a.position);
          }
        });
      });
    }
    ,
    closeMainMenu() {
      if (
        document &&
        document.getElementById("main-nav") &&
        document.getElementById("main-nav").classList
      ) {
        document.getElementById("main-nav").classList.remove("show");
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.close);
    this.$nextTick(() => {
      this.sortMenu();
    });
  },
  destroyed() {
    document.removeEventListener("click", this.close);
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
    }
  },
};
</script>

<style lang="scss" scoped></style>
